import { render, staticRenderFns } from "./SelectBaseGroup.vue?vue&type=template&id=45d11d04"
import script from "./SelectBaseGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBaseGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d11d04')) {
      api.createRecord('45d11d04', component.options)
    } else {
      api.reload('45d11d04', component.options)
    }
    module.hot.accept("./SelectBaseGroup.vue?vue&type=template&id=45d11d04", function () {
      api.rerender('45d11d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/group/base/components/SelectBaseGroup.vue"
export default component.exports